// USO TECNOLÓGICO POR OMISIÓN (Mario, 27-oct): al abrir el paso «Cobros» sin ningún cobro de partida, viene un renglón
// «Uso tecnológico» (porcentaje de lo vendido, al liquidarle) con el `platform_value` del plazo por omisión del tarifario
// (2 % si no hay). Es un renglón más de `charges[]`: se edita, se pausa y se quita. Sin tipos complejos:
// test/condiciones-uso-tecnologico.test.mjs lo carga sin typescript.

export const USO_TECNOLOGICO = 'Uso tecnológico';
export const USO_POR_OMISION = 2;

const sinAcentos = (s: any) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();

/** ¿Este concepto es el uso tecnológico? (sin importar mayúsculas ni tildes) */
export const esUsoTecnologico = (concepto: any) => sinAcentos(concepto) === 'uso tecnologico';

/** El % de uso del plazo por omisión del tarifario (`is_default`, o el primero); 2 si no hay. */
export const usoPorOmision = (rates: any) => {
  const lista = (Array.isArray(rates) ? rates : []).filter((r: any) => r && r.status !== false);
  const r = lista.find((x: any) => x.is_default) || lista[0];
  const v = r && r.platform_value;
  return v === null || v === undefined || v === '' || isNaN(Number(v)) ? USO_POR_OMISION : Number(v);
};

/** Los cobros con que arranca el paso: copia de los de partida; si no hay ninguno, el uso tecnológico. */
export const cobrosIniciales = (charges: any, rates: any) => {
  const base = Array.isArray(charges) ? JSON.parse(JSON.stringify(charges)) : [];
  if (base.length) return base;
  return [{ concept: USO_TECNOLOGICO, description: '', type_calc: 'PERCENTAGE', value: usoPorOmision(rates),
            base: 'SALE', charged_with: 'SETTLEMENT', status: true }];
};
